import BulkOrderGiftCardsShowPage from '../../../components/pages/bulk_order/gift_cards/BulkOrderGiftCardsShowPage.vue'
export default {
  components: { BulkOrderGiftCardsShowPage }
}
